import type { Dispatch, SetStateAction } from 'react'
import { createContext, useContext } from 'react'
import type { JornadaDiaria, JornadaMensal } from 'service/api'
import type { ViewMode } from '../toggle-view'
import type { useUpdateDigitacaoQueryDataNoContext } from './useDigitacaoData'

export type DigitacaoContextValue = {
    data: JornadaDiaria[] | JornadaMensal[]
    view: ViewMode
    changeView: Dispatch<SetStateAction<ViewMode>>
    periodo: [string, string]
    queryParams: Record<string, any>
    setQueryData: ReturnType<
        typeof useUpdateDigitacaoQueryDataNoContext
    >['setQueryData']
    existemFuncionarios: boolean
}

export const DigitacaoContext = createContext<DigitacaoContextValue | null>(
    null,
)

// Rotas de modal podem renderizar num frame em que o provider ainda não
// montou (ex.: F5 direto na URL do modal). Devolver um valor vazio evita
// derrubar a página inteira no ErrorBoundary.
const fallback: DigitacaoContextValue = {
    data: [],
    view: 'mensal',
    changeView: () => void 0,
    periodo: ['', ''],
    queryParams: {},
    setQueryData: (() => void 0) as DigitacaoContextValue['setQueryData'],
    existemFuncionarios: false,
}

export function useDigitacaoContext() {
    const context = useContext(DigitacaoContext)
    if (!context) {
        console.error(
            'useDigitacaoContext usado fora do DigitacaoContext.Provider',
        )
        return fallback
    }
    return context
}
